// HERE IS WHERE ALL OUR SCRIPTS LIE

let body = document.querySelector("body");
let currency = document.querySelector(".currency").innerHTML;
let window_height = 0;
let window_width = 0;
let isTouch = false;

// CART SCRIPTS
// USE OPEN CART TO OPEN THE SIDE CART
function openCart() {
  let miniCart = document.querySelector("#shopify-section-mini-cart .modal");
  miniCart.classList.add("open");
  body.classList.add("no-scroll");
}

// USE CLOSE CART TO CLOSE THE SIDE CART
function closeCart() {
  let miniCart = document.querySelector("#shopify-section-mini-cart .modal");
  miniCart.classList.remove("open");
  body.classList.remove("no-scroll");
}

// USE UPDATE CART WHEN CHANGES HAVE BEEN MADE TO THE CART
function updateCart() {
  fetch(window.Shopify.routes.root + "?sections=mini-cart")
    .then((response) => response.json())
    .then((data) => {
      loadAllProductRecommendations();
      document.querySelector("#shopify-section-mini-cart").outerHTML =
        data["mini-cart"];
      openCart();
    })
    .catch((error) => console.error("Error:", error));
}

function updateCartPage() {
  fetch(window.Shopify.routes.root + "?sections=main-cart-items")
    .then((response) => response.json())
    .then((data) => {
      document.querySelector("div.shopify-section.main-cart-items").outerHTML =
        data["main-cart-items"];
    })
    .catch((error) => console.error("Error:", error));
}

function addCartItem(button) {

  let quantityInput = button.parentElement.querySelector("input[name=quantity]");
  let bundleProducts = button.parentElement.querySelectorAll('select');
  let formData = { items: [] };

  console.log(button);
  console.log(button.parentElement);
  console.log(quantityInput);
  console.log(bundleProducts);

  bundleProducts.forEach(select => {
    // Find the corresponding quantity input for each select
    let selectedOption = select.options[select.selectedIndex];
    let quantity = quantityInput ? quantityInput.value : 1; // Default to 1 if not found

    // Extracting properties from the option's data attributes
    let properties = {
      'Image': selectedOption.getAttribute('data-attr-img'),
      'Title': selectedOption.getAttribute('data-attr-title'),
      'Description': selectedOption.getAttribute('data-attr-desc'),
      'Alt Input': selectedOption.getAttribute('data-alt-v-input'),
      'ID': selectedOption.getAttribute('data-attr-id')
      // Add any other properties as needed
    };

    // Filter out properties that are empty or undefined
    let filteredProperties = Object.fromEntries(Object.entries(properties).filter(([_, v]) => v != null && v !== ''));

    formData.items.push({
      id: select.value,
      quantity: parseInt(quantity, 10), // Ensure quantity is an integer
      properties: filteredProperties
    });
  });

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          document.querySelector(".with-items").classList.add("showing");
          document.querySelector(".with-items").innerText = parseInt(
            data.item_count,
          );

          product_count = data.item_count;
          arr = data.items.map((item) => item.product_id);

          updateCart();
        });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeCartItem(item_key) {
  let formData = {
    updates: {
      [item_key]: 0,
    },
  };

  let bodyclass = body.classList.contains("cart");

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
      .then((response) => response.json())
      .then((data) => {
        if (data.item_count === 0) {
          document.querySelector(".with-items").classList.remove("showing");
        } else {
          document.querySelector(".with-items").innerText = data.item_count;
        }

        if (bodyclass === true) {
          updateCartPage();
        } else {
          updateCart();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
}


function removeBundleItem(bundle_id) {

  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then((response) => response.json())
  .then((data) => {

    // THERE ARE PROPERTIES
    let formData = {updates: {}};

    for(let cartItem of data.items){

      if(Object.keys(cartItem.properties).length > 0){
        if(typeof(cartItem.properties['_bundle-unique-id']) !== 'undefined' && cartItem.properties['_bundle-unique-id'] !== ''){
          if(cartItem.properties['_bundle-unique-id'] === bundle_id){

            let key = cartItem.key
            formData.updates[key] = 0;

          }
        }
      }
    }

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
        .then((response) => response.json())
        .then((data) => {

          let bodyclass = body.classList.contains("cart");

          if (bodyclass === true) {
            updateCartPage();
          } else {
            updateCart();
          }

          if (data.item_count === 0) {
            document.querySelector(".with-items").classList.remove("showing");
          } else {
            document.querySelector(".with-items").innerText = data.item_count;
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });

  });

}

function updateCartQty(item_key, qty, template) {
  let formData = {
    updates: {
      [item_key]: qty,
    },
  };

  let bodyclass = body.classList.contains("cart");

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.item_count === 0) {
        document.querySelector(".with-items").classList.remove("showing");
      } else {
        document.querySelector(".with-items").innerText = data.item_count;
      }
      if (bodyclass === true) {
        updateCartPage();
      } else {
        updateCart();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

let parser = new DOMParser();
let all_products = "";
let products = [];
let related_products_location = document.querySelector(
  ".related-products-full-wrapper .shopify-section",
);

async function loadProductRecommendationsIntoRelated(id) {
  if (
    typeof Shopify.designMode !== "undefined" &&
    Shopify.designMode === true
  ) {
    return;
  }

  if(related_products_location.dataset.attrShowRelated === 'false'){
    return
  }

  const response = await fetch(
    window.Shopify.routes.root +
      `recommendations/products?product_id=${id}&intent=related&limit=3&section_id=mini-cart-related-product-cards`,
  );
  const text = await response.text();
  let doc = parser.parseFromString(text, "text/html");
  let featured_product_not_string = "";
  let featured_product_ids =
    related_products_location.dataset.attrFeaturedids.split(", ");
  for (ids of featured_product_ids) {
    featured_product_not_string +=
      ':not([data-attr-product-id="7171760783422"])';
  }

  let elements = doc.querySelectorAll(
    ".product-card" + featured_product_not_string,
  );

  for (const element of elements) {
    products.push(element.outerHTML);
  }

  return products;
}

// This function will run the loadProductRecommendationsIntoRelated function for each id, waiting for each to complete before moving on to the next.
async function loadAllProductRecommendations() {

  if(related_products_location.dataset.attrShowRelated === 'false'){
    return
  }

  products = [];

  showRelatedProducts(product_count);

  for (let i = 0; i < arr.length; i++) {
    products = await loadProductRecommendationsIntoRelated(arr[i]);
  }

  related_products_location = document.querySelector(
    ".related-products-full-wrapper .shopify-section",
  );
  related_products_location.innerHTML = Array.from(products).join("");
}

function showRelatedProducts(count) {
  let main_minicart_related_wrap = document.querySelector(
    ".mini-cart-related-products.related-products",
  );
  if (showing_minicart_related === false && parseInt(count) > 0) {
    main_minicart_related_wrap.classList.remove("hide");
    main_minicart_related_wrap.classList.add("loaded");
  }
}

// ACCORDIONS
function toggleAccordion(el) {
  el.classList.toggle("open");
}

// MODALS
function openModal(modal_id) {
  let modal = document.querySelector('[data-attr-modal-id="' + modal_id + '"]');
  modal.classList.add("open");
  body.classList.add("no-scroll");
}

function closeModal() {
  let modal = document.querySelector(".open[data-attr-modal]");
  modal.classList.remove("open");
  body.classList.remove("no-scroll");
}

// NAVIGATION
function toggleDropdown(el) {
  el.closest("li").classList.toggle("open");
}

// FILTERS
function openFilters() {
  let miniCart = document.querySelector(".modal.filters");
  miniCart.classList.add("open");
  body.classList.add("no-scroll");
}

function closeFilters() {
  let miniCart = document.querySelector(".modal.filters");
  miniCart.classList.remove("open");
  body.classList.remove("no-scroll");
}

// PRODUCT FORM
function changeProductQTY(el, direction) {
  let qty_switcher = el.closest(".qty-switcher");
  let qty_input = qty_switcher.querySelector("input");

  let qty = parseInt(qty_input.value);

  if (direction === "minus") {
    qty = qty - 1;
    if (qty === 0) {
      qty = 1;
    }
  } else {
    qty = qty + 1;
  }

  qty_input.value = qty;
}

// START OF VIDEO WORK
let mute = true;
let currentlyScrolling = null;
let manualPause = false;

let touchStartY = 0;
let touchStartX = 0;
const tolerance = 10;

function videoBlocks() {
  let videoBlocks = document.querySelectorAll(".video-block");

  videoBlocks.forEach((video) => {
    video.querySelector(".paused").addEventListener("touchstart", function (e) {
      touchStartY = e.touches[0].clientY;
      touchStartX = e.touches[0].clientX;
    });
    video.querySelector(".paused").addEventListener("touchend", function (e) {
      // If the start and end positions are the same, it was a tap, not a scroll
      if (
        Math.abs(e.changedTouches[0].clientY - touchStartY) < tolerance &&
        Math.abs(e.changedTouches[0].clientX - touchStartX) < tolerance
      ) {
        if (video.querySelector("video").paused === false) {
          // IF SOMEONE IS CLICKING ON THE VIDEO THAT'S PLAYING WE WANT TO PAUSE IT
          currentlyScrolling.classList.add("pause");
          currentlyScrolling.classList.remove("playing");
          manualPause = true;
          currentlyScrolling.pause();
          return;
        }

        manualPause = false;

        currentlyScrolling.classList.remove("pause");
        currentlyScrolling.classList.remove("playing");
        currentlyScrolling.pause();

        video.querySelector("video").play();
        currentlyScrolling = video.querySelector("video");
        if (mute === false) {
          video.querySelector("video").muted = false;
        }
        video.classList.add("hide-image");
        video.classList.add("playing");
      }
    });
    video.onmouseover = function () {
      if (isTouch === false) {
        video.querySelector("video").play();
        if (mute === false) {
          video.querySelector("video").muted = false;
        }
        video.classList.add("hide-image");
        video.classList.add("playing");
      }
    };
    video.onmouseout = function () {
      if (isTouch === false) {
        video.querySelector("video").pause();
        video.querySelector("video").classList.remove("playing");
      }
    };
  });

  let muteButton = document.querySelectorAll(".mute-button");
  muteButton.forEach((button) => {
    button.onclick = function () {
      if (mute === false) {
        mute = true;
        button.parentElement.querySelector("video").muted = true;
        document.body.classList.remove("video-sound");
      } else {
        mute = false;
        button.parentElement.querySelector("video").muted = false;
        document.body.classList.add("video-sound");
      }
    };
  });
}

function videoBlockScrolling() {
  // HERE IS WHERE WE WORK OUT IF WE'RE LISTNING FOR SCORLLING FOR VIDEO PLAYING
  let videoWrappers = document.querySelectorAll(
    ".scrollable-videos .scrollable",
  );

  // NO VIDEO WRAPPERS EXIST SO WE CANCEL OUT OF THE FUNCTION
  if (videoWrappers.length === 0) {
    return;
  }

  // WE WANT THE ACTUAL VIDEOS NOT THE TITLES
  let firstVideos = document.querySelectorAll(
    ".scrollable-videos .video-block:first-child",
  );

  let scrolling;
  let horizontal_scrolling;
  window.addEventListener("scroll", function (e) {
    if (manualPause === true) {
      return;
    }

    if (currentlyScrolling !== null) {
      currentlyScrolling.pause();
      currentlyScrolling.classList.remove("playing");
    }

    if (scrolling) clearTimeout(scrolling);

    scrolling = setTimeout(function () {
      firstVideos.forEach((video) => {
        // WE WANT AT LEAST 20% OF THE VIDEO SHOWING
        if (
          (video.getBoundingClientRect().top > 0 &&
            video.getBoundingClientRect().top < window.innerHeight * 0.8) ||
          (video.getBoundingClientRect().bottom < window.innerHeight &&
            video.getBoundingClientRect().bottom > window.innerHeight * 0.2)
        ) {
          // FIND THE FIRST VISIBLE VIDEO AND PLAY IT
          let all_videos_wrap = video.parentElement;
          let all_videos = all_videos_wrap.querySelectorAll(".video-block");
          let showing = false;
          all_videos.forEach((video_element) => {
            // ANY NEGATIVE LEFT MEANS IT'S OFF SCREEN, WE WANT THE FIRST VIDEO PLAYING
            if (
              video_element.getBoundingClientRect().left > 0 &&
              showing === false
            ) {
              showing = true;
              currentlyScrolling = video_element.querySelector("video");

              video_element.querySelector("video").play();
              if (mute === false) {
                video_element.querySelector("video").muted = false;
              }
              video_element.classList.add("hide-image");
              video_element.classList.add("playing");

              return false;
            }
          });
        }
      });
    }, 100);
  });

  videoWrappers.forEach((wrapper) => {
    let firstVideo = wrapper.querySelector(".video-block:first-child");

    wrapper.addEventListener("scroll", function (e) {
      if (manualPause === true) {
        return;
      }

      if (currentlyScrolling !== null) {
        currentlyScrolling.pause();
        currentlyScrolling.classList.remove("playing");
      }

      if (horizontal_scrolling) clearTimeout(horizontal_scrolling);

      horizontal_scrolling = setTimeout(function () {
        // WE WANT AT LEAST 20% OF THE VIDEO SHOWING
        if (
          (firstVideo.getBoundingClientRect().top > 0 &&
            firstVideo.getBoundingClientRect().top <
              window.innerHeight * 0.8) ||
          (firstVideo.getBoundingClientRect().bottom < window.innerHeight &&
            firstVideo.getBoundingClientRect().bottom >
              window.innerHeight * 0.2)
        ) {
          // FIND THE FIRST VISIBLE VIDEO AND PLAY IT
          let all_videos_wrap = firstVideo.parentElement;
          let all_videos = all_videos_wrap.querySelectorAll(".video-block");
          let showing = false;
          all_videos.forEach((video_element) => {
            // ANY NEGATIVE LEFT MEANS IT'S OFF SCREEN, WE WANT THE FIRST VIDEO PLAYING
            if (
              video_element.getBoundingClientRect().left > 0 &&
              showing === false
            ) {
              showing = true;
              currentlyScrolling = video_element.querySelector("video");

              video_element.querySelector("video").play();
              if (mute === false) {
                video_element.querySelector("video").muted = false;
              }
              video_element.classList.add("hide-image");
              video_element.classList.add("playing");

              return false;
            }
          });
        }
      }, 100);
    });
  });

  // WE WANT AT LEAST 20% OF THE VIDEO SHOWING

  // WE BUILD OUT AN ARRAY OF ALL VIDEOWRAPPERS SO WE DON'T HAVE TO CONSTANTLY FIND THEM
}
// END OF VIDEO WORK

// START OF CURRENCY SELECTOR WORK
function countrySwitcherSetup() {
  let options = { searchable: true };

  let footerSelect = NiceSelect.bind(
    document.getElementById("footer-select"),
    options,
  );

  let mobileSelect = NiceSelect.bind(
    document.getElementById("mobile-select"),
    options,
  );
}

function countrySwitcherChange(el) {

  console.log("countrySwitcherChange", el);

  let selectedCountry = el.options[el.selectedIndex].dataset.attrCountry;
  let selectedLanguage = el.options[el.selectedIndex].dataset.attrLanguage;

  console.log("selectedCountry", selectedCountry);
  console.log("selectedLanguage", selectedLanguage);

  updateLocalization({country: selectedCountry, language: selectedLanguage});
}

function updateLocalization({country, language}) {
  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  document.getElementById(formId).submit();
}

// TEST IF USER IS ON MOBILE / TOUCH
window.addEventListener(
  "touchstart",
  function onFirstTouch() {
    isTouch = true;
    videoBlockScrolling();

    // we only need to know once that a human touched the screen, so we can stop listening now
    window.removeEventListener("touchstart", onFirstTouch, false);
  },
  false,
);

window.onload = function () {
  videoBlocks();
  loadAllProductRecommendations();
};
